import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberNormasymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1364_2022)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M26.7595 51.7358C26.4092 51.4024 26.071 51.0571 25.7208 50.688C25.5638 50.5332 25.4068 50.3546 25.2618 50.1998L24.7304 49.6521C24.5251 49.4259 24.3198 49.1996 24.1144 48.9734L23.7642 48.6043C23.5226 48.3304 23.2811 48.0565 23.0516 47.7827L22.8704 47.5803C22.5926 47.2588 22.3269 46.9373 22.0612 46.6158L22.0371 46.5801C13.8966 36.6734 8.95681 24.5877 7.88188 11.8947C7.77318 10.6802 7.70072 9.46567 7.67656 8.23924V8.08445C7.67656 7.53673 7.65241 6.989 7.65241 6.44127V6.04834C5.73204 6.72704 3.8479 7.47719 2 8.29878C2.06039 10.3111 2.19324 12.3115 2.42272 14.2761C4.42764 31.8153 13.1599 47.9494 26.8319 59.404C28.3296 60.6661 29.8755 61.8569 31.4819 62.9999C33.0882 61.8688 34.6463 60.6781 36.1439 59.404C34.5376 58.3324 32.9795 57.1893 31.4819 55.9748C29.8393 54.6412 28.2571 53.2361 26.7474 51.7477H26.7595V51.7358Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M13.3531 4.29808C13.329 5.0006 13.3169 5.71502 13.3169 6.42945C13.3169 7.64397 13.3531 8.84659 13.4256 10.0492C27.158 6.19131 41.7842 6.83429 55.106 11.8948C53.8137 26.9454 47.1347 41.0672 36.2405 51.724L35.7695 52.1765C37.2792 53.3553 38.8252 54.4507 40.4315 55.4866C51.688 44.3654 58.7898 29.8388 60.5773 14.2643C60.8068 12.2996 60.9517 10.3112 61 8.28695C59.1642 7.45346 57.28 6.70331 55.3476 6.03652C41.8446 1.33322 27.2063 0.725954 13.3531 4.29808Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1364_2022",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 59,
			height: 61,
			fill: "white",
			transform: "translate(2 2)"
		})
	}) })]
});
export default SvgCyberNormasymbol;
